import React from "react"
import { PalletStateType } from "store/production.reducer"
import { getTotalBoxes } from "./labelHelpers"

interface LabelPalletNoProps {
  pallet: PalletStateType
  production: any
  compact?: boolean
}

export default function LabelPalletNo({
  pallet,
  production,
  compact = false,
}: LabelPalletNoProps) {
  // Scale text down when two labels share one sticker
  const fs = (n: number) => (compact ? Math.round(n * 0.65) : n)

  const totalBoxes = getTotalBoxes(pallet)
  const capacity = production?.shipmentPlan?.skuType?.capacity ?? 5
  const farmRows = (pallet?.mhCodes ?? []).reduce((acc, curr) => {
    const existing = acc.find(item => item.code === curr.mhCode)
    if (existing) {
      existing.boxes += Math.round(curr.boxes)
    } else {
      acc.push({ code: curr.mhCode, boxes: curr.boxes?.toFixed(2) })
    }
    return acc
  }, [] as { code: string; boxes: string }[])

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        color: "#000",
        background: "#fff",
        border: "1px solid #000",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          textAlign: "center",
          paddingTop: "6px",
          paddingBottom: "4px",
          fontSize: fs(18),
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        PALLET NO
      </div>

      <div style={{ padding: "0 6px", marginBottom: "6px" }}>
        <div
          style={{
            backgroundColor: "#000",
            color: "#fff",
            textAlign: "center",
            fontSize: fs(44),
            fontWeight: 800,
            padding: "2px 0",
            letterSpacing: 1,
          }}
        >
          {pallet?.palletNumber?.slice(0, -1).slice(-6) ?? "--"}
        </div>
      </div>

      <div style={{ borderTop: "1px solid #000" }} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: compact ? "2px 8px" : "4px 16px",
          fontSize: fs(18),
          fontWeight: 600,
        }}
      >
        <span>Code</span>
        <span>Box</span>
      </div>

      <div style={{ borderTop: "1px solid #000" }} />

      <div
        style={{
          flex: 1,
          padding: compact ? "6px 8px" : "12px 16px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {farmRows.length > 0 ? (
          farmRows.map((row, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: fs(18),
                fontWeight: 600,
                marginBottom: compact ? "4px" : "8px",
              }}
            >
              <span>{row.code}</span>
              <span>{row.boxes}</span>
            </div>
          ))
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: fs(18),
              fontWeight: 600,
            }}
          >
            <span>--</span>
            <span>--</span>
          </div>
        )}
      </div>

      <div style={{ borderTop: "1px solid #000" }} />

      <div
        style={{
          padding: compact ? "2px 8px" : "4px 12px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: fs(16),
          fontWeight: 600,
        }}
      >
        <span>TOTAL BOX :-</span>
        <span>{totalBoxes}</span>
      </div>

      <div style={{ borderTop: "1px solid #000" }} />

      <div
        style={{
          padding: compact ? "2px 8px" : "4px 12px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: fs(16),
          fontWeight: 600,
        }}
      >
        <span>PER BOX Wt :-</span>
        <span>{capacity} Kg</span>
      </div>
    </div>
  )
}
